
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[feature]",
      function () {
        return require("private-next-pages/[feature].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[feature]"])
      });
    }
  